import Vue from 'vue';
import CSPLoader from '@/components/LoadingDialog.vue';
import Appbar from '@/components/Appbar.vue'
import SearchBar from '@/components/SearchBar.vue';
import CardToolbar from '@/components/Controls/Card-Toolbar.vue';
import CardActions from '@/components/Controls/Card-Action.vue';

Vue.component('CSPLoader', CSPLoader);
Vue.component('SearchBar', SearchBar);
Vue.component('CardToolbar', CardToolbar);
Vue.component('CardActions', CardActions);
Vue.component('Appbar', Appbar);